import { render, staticRenderFns } from "./PmtaRelayGroup.vue?vue&type=template&id=2f29f800&scoped=true"
import script from "./PmtaRelayGroup.vue?vue&type=script&lang=js"
export * from "./PmtaRelayGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f29f800",
  null
  
)

export default component.exports